<template>
  <Form :submit-function="updateSiteInfo" :editable=true />
</template>

<script>
import Form from './Form';

export default {
  name: "Update",
  components: {Form},
  methods: {
    updateSiteInfo(form) {
      console.log(form, 'update');
      this.$store.dispatch('SiteInfo/updateSiteInfo', form);
    }
  }
}
</script>

<style scoped>

</style>